import { render, staticRenderFns } from "./AddFace.vue?vue&type=template&id=ea1674b8&scoped=true&"
import script from "./AddFace.vue?vue&type=script&lang=js&"
export * from "./AddFace.vue?vue&type=script&lang=js&"
import style0 from "./AddFace.vue?vue&type=style&index=0&id=ea1674b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1674b8",
  null
  
)

export default component.exports